/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateCollectionMutationVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
  name: Types.Scalars["String"]["input"];
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  emoji: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  memberUserIds:
    | ReadonlyArray<Types.Scalars["UserId"]["input"]>
    | Types.Scalars["UserId"]["input"];
  memberGroupIds:
    | ReadonlyArray<Types.Scalars["GroupId"]["input"]>
    | Types.Scalars["GroupId"]["input"];
  memberIntrinsicGroupIds:
    | ReadonlyArray<Types.IntrinsicGroupId>
    | Types.IntrinsicGroupId;
  managerIntrinsicGroupIds:
    | ReadonlyArray<Types.IntrinsicGroupId>
    | Types.IntrinsicGroupId;
  managerUserIds:
    | ReadonlyArray<Types.Scalars["UserId"]["input"]>
    | Types.Scalars["UserId"]["input"];
  managerGroupIds:
    | ReadonlyArray<Types.Scalars["GroupId"]["input"]>
    | Types.Scalars["GroupId"]["input"];
}>;

export type CreateCollectionMutation = {
  readonly __typename: "Mutation";
  readonly createCollection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly name: string;
  };
};

export const CreateCollectionDocument = /*#__PURE__*/ gql`
  mutation CreateCollection(
    $orgId: OrgId!
    $name: String!
    $description: String
    $emoji: String
    $memberUserIds: [UserId!]!
    $memberGroupIds: [GroupId!]!
    $memberIntrinsicGroupIds: [IntrinsicGroupId!]!
    $managerIntrinsicGroupIds: [IntrinsicGroupId!]!
    $managerUserIds: [UserId!]!
    $managerGroupIds: [GroupId!]!
  ) {
    createCollection(
      orgId: $orgId
      name: $name
      description: $description
      emoji: $emoji
      memberUserIds: $memberUserIds
      memberGroupIds: $memberGroupIds
      memberIntrinsicGroupIds: $memberIntrinsicGroupIds
      managerIntrinsicGroupIds: $managerIntrinsicGroupIds
      managerUserIds: $managerUserIds
      managerGroupIds: $managerGroupIds
    ) {
      id
      name
    }
  }
`;
export type CreateCollectionMutationFn = Apollo.MutationFunction<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      emoji: // value for 'emoji'
 *      memberUserIds: // value for 'memberUserIds'
 *      memberGroupIds: // value for 'memberGroupIds'
 *      memberIntrinsicGroupIds: // value for 'memberIntrinsicGroupIds'
 *      managerIntrinsicGroupIds: // value for 'managerIntrinsicGroupIds'
 *      managerUserIds: // value for 'managerUserIds'
 *      managerGroupIds: // value for 'managerGroupIds'
 *   },
 * });
 */
export function useCreateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCollectionMutation,
    CreateCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCollectionMutation,
    CreateCollectionMutationVariables
  >(CreateCollectionDocument, options);
}
export type CreateCollectionMutationHookResult = ReturnType<
  typeof useCreateCollectionMutation
>;
export type CreateCollectionMutationResult =
  Apollo.MutationResult<CreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>;
